module.exports = __webpack_public_path__ + "img/clubmed_rm.b0df13a9.png";